module.exports = __webpack_public_path__ + "73678d36850ad64e7d9271446b691a7a.jpeg";